/* ===== Anadita Luxe — predictive search ===== */
(function () {
  'use strict';
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  if (!input || !results) return;
  var timer, controller;
  var money = function (cents) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2); };

  function run(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: controller.signal }).then(function (r) { return r.json(); }).then(function (data) {
      var res = data.resources.results;
      var html = '';
      if (res.queries && res.queries.length) {
        html += '<div class="predictive-search__group"><h4>Suggestions</h4><ul role="list">';
        res.queries.forEach(function (qx) { html += '<li><a href="/search?q=' + encodeURIComponent(qx.text) + '">' + qx.text + '</a></li>'; });
        html += '</ul></div>';
      }
      if (res.products && res.products.length) {
        html += '<div class="predictive-search__group"><h4>Products</h4><ul role="list" class="predictive-search__products">';
        res.products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=120" alt="" loading="lazy">' : '';
          html += '<li><a href="' + p.url + '">' + img + '<span><strong>' + p.title + '</strong>' + (p.price ? '<em>' + money(p.price) + '</em>' : '') + '</span></a></li>';
        });
        html += '</ul></div>';
      }
      if (res.collections && res.collections.length) {
        html += '<div class="predictive-search__group"><h4>Collections</h4><ul role="list">';
        res.collections.forEach(function (c) { html += '<li><a href="' + c.url + '">' + c.title + '</a></li>'; });
        html += '</ul></div>';
      }
      if (!html) html = '<p class="predictive-search__empty">No matches. Press Enter to search anyway.</p>';
      results.innerHTML = html;
      results.removeAttribute('hidden');
    }).catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.setAttribute('hidden', ''); results.innerHTML = ''; return; }
    timer = setTimeout(function () { run(q); }, 220);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-search-panel]')) results.setAttribute('hidden', '');
  });
})();
